// extracted by mini-css-extract-plugin
module.exports = {"bundle":"bundle_bundle__nocMR","trash":"bundle_trash__NdD0A"};